// client/src/components/auth/profile/EmailPreferencesCard.js
import React, { useState, useEffect, useRef } from 'react'
import addRipple from '../../../utils/ripple'
import '../../../styles/profileFields.css'

function EmailPreferencesCard({
  userData,
  onUserDataChange,
  isEditing,
  onEditClick,
  editingField,
  onInlineSave,
  onInlineCancel,
}) {
  const [weeklyEmailOptIn, setWeeklyEmailOptIn] = useState(
    userData?.weekly_email_opt_in ?? true,
  )
  const wasEditingRef = useRef(false)

  useEffect(() => {
    if (wasEditingRef.current && !isEditing) {
      setWeeklyEmailOptIn(userData?.weekly_email_opt_in ?? true)
    }
    wasEditingRef.current = isEditing
  }, [isEditing, userData?.weekly_email_opt_in])

  const handleToggleChange = (e) => {
    const value = e.target.checked
    setWeeklyEmailOptIn(value)
    onUserDataChange({ weekly_email_opt_in: value })
  }

  const isFieldEditing = isEditing && editingField === 'weekly_email_opt_in'

  return (
    <div
      className="profile-card"
      role="region"
      aria-labelledby="email-prefs-title"
    >
      <h5 id="email-prefs-title" className="section-title">
        📧 Email Preferences
      </h5>
      <p className="profile-card-description">
        Receive weekly emails with your upcoming matches, league standings, and
        important announcements.
      </p>
      {!isFieldEditing && (
        <button
          type="button"
          className="field-chip full-width"
          onClick={(e) => {
            addRipple(e)
            onEditClick('weekly_email_opt_in')
          }}
        >
          <span className="chip-label">Weekly emails</span>
          <span className="chip-value">{weeklyEmailOptIn ? 'On' : 'Off'}</span>
        </button>
      )}
      {isFieldEditing && (
        <div
          className="field-chip editing full-width"
          data-field="weekly_email_opt_in"
        >
          <span className="chip-label">Weekly emails</span>
          <div className="chip-editor">
            <div className="form-check form-switch">
              <input
                className="form-check-input"
                type="checkbox"
                id="weekly-email-opt-in"
                data-testid="weekly-email-toggle"
                checked={weeklyEmailOptIn}
                onChange={handleToggleChange}
              />
              <label className="form-check-label" htmlFor="weekly-email-opt-in">
                Receive weekly emails
              </label>
            </div>
            <div className="chip-actions">
              <button
                type="button"
                className="icon-btn confirm"
                onClick={() =>
                  onInlineSave && onInlineSave('weekly_email_opt_in')
                }
                aria-label="Save"
              >
                ✓
              </button>
              <button
                type="button"
                className="icon-btn cancel"
                onClick={() =>
                  onInlineCancel && onInlineCancel('weekly_email_opt_in')
                }
                aria-label="Cancel"
              >
                ✕
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  )
}

export default EmailPreferencesCard
